import { useContext, useEffect } from 'react'

import ExternalServicesContext from 'contexts/ExternalServicesContext'

import constants from 'constants/index'

const { REACHABILITY } = constants.externalServices

// Responde "ESTE navegador alcança o serviço?" - nunca "o serviço está no ar?",
// que é o upstreamStatus vindo do catálogo. A verificação é preguiçosa: montar
// este hook é o que a dispara para aquela key.
const useBrowserReachability = (key) => {
  const context = useContext(ExternalServicesContext)

  if (context === undefined) {
    throw new Error(
      'useBrowserReachability must be used within an ExternalServicesContext.Provider',
    )
  }

  const { catalog, reachabilityByKey, probeOnce, markUnreachable } = context

  const serviceEntry = catalog[key]

  useEffect(() => {
    if (serviceEntry) probeOnce(key)
    //eslint-disable-next-line
  }, [key, serviceEntry])

  const browserReachability = reachabilityByKey[key] || REACHABILITY.CHECKING

  return {
    // Enquanto a verificação corre a superfície segue disponível, para o caminho
    // feliz não piscar. Só o veredito de inalcançável fecha a porta.
    isReachable: browserReachability !== REACHABILITY.UNREACHABLE,
    markUnreachable: () => markUnreachable(key),
  }
}

export default useBrowserReachability
